import homeSectionStyles from './HomeSection.module.scss';

const HomeSection = () => (
  <section id="home-section" className={homeSectionStyles.home} aria-labelledby="home-title">
    <div className={homeSectionStyles.homeContent}>
      <h1 id="home-title" className={homeSectionStyles.heroTitle}>
        <span className={homeSectionStyles.heroMain}>Collecting <span className={homeSectionStyles.highlight}>mobile application reviews</span> & generating responses with <span className={homeSectionStyles.highlightAI}>AI</span></span>
      </h1>
      <p className={homeSectionStyles.heroSubtitle}>
        <span className={homeSectionStyles.highlightBrand}>mobiyo</span> collects customer reviews for your mobile application, analyzes comments and generates responses with <span className={homeSectionStyles.highlightAI}>AI</span>
      </p>
    </div>
  </section>
);

export default HomeSection; 
